var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6665 4.00008C23.0167 3.64989 23.4324 3.3721 23.89 3.18258C24.3475 2.99305 24.8379 2.89551 25.3332 2.89551C25.8284 2.89551 26.3188 2.99305 26.7764 3.18258C27.2339 3.3721 27.6496 3.64989 27.9998 4.00008C28.35 4.35027 28.6278 4.76601 28.8173 5.22355C29.0069 5.6811 29.1044 6.1715 29.1044 6.66674C29.1044 7.16199 29.0069 7.65239 28.8173 8.10993C28.6278 8.56748 28.35 8.98322 27.9998 9.33341L9.99984 27.3334L2.6665 29.3334L4.6665 22.0001L22.6665 4.00008Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#11111",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7e97eb60050c4a4ee1c14c77d08026ff.svg";
export { ForwardRef as ReactComponent };